/**
 * Status Helpers
 *
 * Pure stateless utilities for message template / broadcast status display.
 *
 * Migrated from: src/mixins/global.js
 */

type TemplateStatus =
  | 'draft'
  | 'pending'
  | 'approved'
  | 'rejected'
  | 'in_appeal'
  | 'pending_deletion'
  | 'deleted'
  | 'disabled'
  | 'paused'
  | 'limit_exceeded'
  | string

/**
 * Returns a human-readable label for a template/broadcast status value.
 */
export function getStatusLabel(status: TemplateStatus): string {
  switch (status) {
    case 'draft':            return 'Draft'
    case 'pending':          return 'Pending'
    case 'approved':         return 'Approved'
    case 'rejected':         return 'Rejected'
    case 'in_appeal':        return 'In appeal'
    case 'pending_deletion': return 'Pending deletion'
    case 'deleted':          return 'Deleted'
    case 'disabled':         return 'Disabled'
    case 'paused':           return 'Paused'
    case 'limit_exceeded':   return 'Limit exceeded'
    default:                 return ''
  }
}

/**
 * Returns a CSS class map for a given status value.
 * Intended for use with `:class` bindings.
 */
export function statusClass(status: TemplateStatus): Record<string, boolean> {
  return {
    status_approved: status === 'approved',
    status_rejected:
      status === 'rejected' ||
      status === 'limit_exceeded' ||
      status === 'disabled' ||
      status === 'deleted',
    status_pending:
      status === 'pending' ||
      status === 'in_appeal' ||
      status === 'pending_deletion' ||
      status === 'paused',
    status_draft: status === 'draft',
  }
}
